// This file is auto-generated during build process
// Do not edit manually - it will be overwritten

export interface MicroSRPConfig {
  VITE_CX_URL: string;
  VITE_CDN_URL: string;
  VITE_CDN_ID: string;
  VITE_INVENTORY_API: string;
  VITE_IMAGE_SERVICE_API: string;
  VITE_JAMS_BACKEND_URL: string;
  VITE_JAMS_FRONTEND_URL: string;
  VITE_MUST_ENDPOINT: string;
  NPM_TOKEN: string;
  COMPONENTS_BUCKET_NAME: string;
}

export const config: MicroSRPConfig = {
  VITE_CX_URL: 'https://microsrp.cx.dev.sodasoft.io',
  VITE_CDN_URL: 'https://d30yj9jglnh5th.cloudfront.net',
  VITE_CDN_ID: 'EVADZECPUWBGD',
  VITE_INVENTORY_API: 'https://xvu8b6jyrf.execute-api.us-west-2.amazonaws.com/dev',
  VITE_IMAGE_SERVICE_API: 'https://media-a5-jazel-tango.jazel-qa.com',
  VITE_JAMS_BACKEND_URL: 'https://a32xerzekl.execute-api.us-west-2.amazonaws.com/dev',
  VITE_JAMS_FRONTEND_URL: 'https://jams.admin.dev.sodasoft.io',
  VITE_MUST_ENDPOINT: 'https://za7ksuje0g.execute-api.us-east-1.amazonaws.com',
  NPM_TOKEN: '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',
  COMPONENTS_BUCKET_NAME: 'jazel-lightning-components'
};

export default config;
